module.exports = __webpack_public_path__ + "img/1109.bfac668b.gif";